//篮球 杯赛 FIBA Women's Asia Cup|国际篮联女子亚洲杯 full
import PlatfromBasketballFIBAMAFull from '@containers/platfrom_basketball/basketballCupFull_FIBAMA'

export default {
  PlatfromBasketballFIBAMAFull,
}
